import { queryOptions, type MutationOptions, type QueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

async function fetchPlaylists() {
	const response = await api.api.playlists.get()
	if (response.error) {
		throw new Error('Failed to fetch playlists')
	}
	return response.data
}

export const playlistsQueryOptions = queryOptions({
	queryKey: ['playlists'],
	queryFn: fetchPlaylists,
})

async function fetchPlaylist(id: string) {
	const response = await api.api.playlists({ id }).get()
	if (response.error) {
		throw new Error('Failed to fetch playlist')
	}
	return response.data
}

export function playlistQueryOptions(id: string) {
	return queryOptions({
		queryKey: ['playlists', id],
		queryFn: () => fetchPlaylist(id),
	})
}

async function reorderPlaylists(orderedIds: string[]) {
	const response = await api.api.playlists.reorder.patch({ orderedIds })
	if (response.error) {
		throw new Error('Failed to reorder playlists')
	}
	return response.data
}

export function reorderPlaylistsMutationOptions(queryClient: QueryClient): MutationOptions<unknown, Error, string[]> {
	return {
		mutationFn: reorderPlaylists,
		onError: () => {
			queryClient.invalidateQueries(playlistsQueryOptions)
		},
	}
}
